var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.97C2.34 9.97 2 9.64 2 9.22V6.91C2 4.2 4.2 2 6.91 2H9.22C9.63 2 9.97 2.34 9.97 2.75C9.97 3.16 9.64 3.5 9.22 3.5H6.91C5.03 3.5 3.5 5.03 3.5 6.91V9.22C3.5 9.64 3.16 9.97 2.75 9.97Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2498 9.97C20.8398 9.97 20.4998 9.63 20.4998 9.22V6.91C20.4998 5.03 18.9698 3.5 17.0898 3.5H14.7798C14.3698 3.5 14.0298 3.16 14.0298 2.75C14.0298 2.34 14.3598 2 14.7798 2H17.0898C19.7998 2 21.9998 4.2 21.9998 6.91V9.22C21.9998 9.64 21.6598 9.97 21.2498 9.97Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0902 22H15.7002C15.2902 22 14.9502 21.66 14.9502 21.25C14.9502 20.84 15.2902 20.5 15.7002 20.5H17.0902C18.9702 20.5 20.5002 18.97 20.5002 17.09V15.7C20.5002 15.29 20.8402 14.95 21.2502 14.95C21.6602 14.95 22.0002 15.29 22.0002 15.7V17.09C22.0002 19.8 19.8002 22 17.0902 22Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22 22H6.91C4.2 22 2 19.8 2 17.09V14.78C2 14.37 2.34 14.03 2.75 14.03C3.16 14.03 3.5 14.37 3.5 14.78V17.09C3.5 18.97 5.03 20.5 6.91 20.5H9.22C9.63 20.5 9.97 20.84 9.97 21.25C9.97 21.66 9.64 22 9.22 22Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.0f1d9b8891a3ef0bbcf11f686ef69dba.svg";
export { ForwardRef as ReactComponent };